import { BrowserRouter } from 'react-router-dom';
import { PlayerProvider } from './player/PlayerContext';
import Shell from './components/Shell';

export default function App() {
  return (
    <BrowserRouter>
      <PlayerProvider>
        <Shell />
      </PlayerProvider>
    </BrowserRouter>
  );
}
